var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChronicDiseaseScreening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.881,
    cy: 20,
    rx: 19.881,
    ry: 20,
    fill: "#FCE6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9243 9.73568L20.4248 11.2442C20.1245 11.5463 19.6377 11.5463 19.3374 11.2442L17.8379 9.73568C14.2121 6.08818 8.33349 6.08818 4.70762 9.73568C1.08183 13.3832 1.08183 19.297 4.70762 22.9446L17.1588 35.4703C18.6623 36.9828 21.1 36.9828 22.6035 35.4703L35.0547 22.9446C38.6804 19.2971 38.6804 13.3833 35.0547 9.73568C31.4287 6.08811 25.5501 6.08811 21.9243 9.73568Z",
    fill: "#EF6680"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1328 21.045C33.1328 20.3972 32.6108 19.8721 31.9669 19.8721H30.7746C30.0005 19.8721 29.3182 20.3605 29.0364 21.1163L28.1382 23.5249C27.9944 23.9104 27.7262 24.1246 27.4044 24.1131C27.0731 24.1011 26.804 23.8507 26.6845 23.4433L24.1061 14.6516C23.8636 13.825 23.1467 13.2695 22.3221 13.2695C21.4974 13.2695 20.7805 13.825 20.538 14.6516L17.4387 25.2193L15.3175 17.9864C14.9124 16.6052 13.7831 15.6812 12.4405 15.6326C11.1094 15.5844 9.93102 16.4133 9.43472 17.7444L8.93898 19.0739C8.75991 19.554 8.30361 19.8721 7.79391 19.8721C7.14998 19.8721 6.62793 20.3972 6.62793 21.045V21.0498C6.62793 21.6976 7.14998 22.2228 7.79391 22.2228H8.98628C9.7603 22.2228 10.4426 21.7345 10.7245 20.9786L11.6226 18.57C11.7663 18.1845 12.0331 17.9685 12.3564 17.9818C12.6877 17.9938 12.9568 18.2442 13.0763 18.6516L15.6547 27.4431C15.8971 28.2698 16.6141 28.8253 17.4388 28.8253C18.2635 28.8253 18.9804 28.2699 19.2229 27.4431L22.3222 16.8755L24.4434 24.1084C24.8485 25.4897 25.9778 26.4136 27.3205 26.4622C28.6483 26.5107 29.8299 25.6815 30.3262 24.3505L30.822 23.021C31.0011 22.5409 31.4574 22.2228 31.9671 22.2228C32.611 22.2228 33.1331 21.6977 33.1331 21.0498V21.045H33.1328Z",
    fill: "#E4002B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChronicDiseaseScreening);
export default __webpack_public_path__ + "static/media/ChronicDiseaseScreening.2a8d97ba1ffdd909cbba7b3f9ed9e635.svg";
export { ForwardRef as ReactComponent };